import React from "react";

const ReceiptHeader = ({ office, subs }) => {
  return (
    <div className="">
      <div className="header">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
            paddingBottom: "2px",
            borderBottom: "solid 2px black",
          }}
        >
          <img className="py-2" src="../images/logo.png" alt="Intitution Logo" style={{ maxWidth: 80 }} />
          <div style={{ paddingTop: 10, fontSize: 12, textAlign:"center" }}>
            <h1
              style={{
                marginTop: 0,
                marginBottom: 3,
                fontSize: 15,
              }}
            >
              Kebbi State Polytechnic Dakingari
            </h1>
            
            <div className="text-uppercase">Nasarawa Annex Campus, Dakingari, Kebbi STATE</div>
          </div>

        </div>
      </div>

    </div>
  );
};

export default ReceiptHeader;
